<template>
	<header class="header-mobile">
		<div class="header-mobile__upper">
			<div class="header-mobile__wrapper">
				<router-link to="/">
					<img src="@/assets/images/header/logo.png" alt class="header-mobile__logo" />
				</router-link>

				<a href="#" @click.prevent="toggleMenu" class="header-mobile__nav-toggle">
					<svg width="30" height="30">
						<path d="M0,5 30,5" stroke="#505050" stroke-width="2" />
						<path d="M0,14 30,14" stroke="#505050" stroke-width="2" />
						<path d="M0,23 30,23" stroke="#505050" stroke-width="2" />
					</svg>
				</a>
				<nav class="header-mobile__nav" :style="{transform: `translateX(${translate})`}">
					<div class="header-mobile__nav-header">
						<router-link to="/" @click.native="toggleMenu">
							<img src="@/assets/images/header/logo.png" alt class="header-mobile__logo" />
						</router-link>
						<a href="#" @click.prevent="toggleMenu" data-test-ref="navMenuLink">
							<svg width="30" height="30">
								<path d="M5,5 25,25" stroke="#505050" stroke-width="2" />
								<path d="M5,25 25,5" stroke="#505050" stroke-width="2" />
							</svg>
						</a>
					</div>
					<router-link @click.native="toggleMenu" v-for="link in navTop" :key="link.link" :to="link.link" class="header-mobile__link">
						<img :src="require(`@/assets/svg/${link.icon}.svg`)" alt="" class="header-mobile__icon">
						{{ link.desc }}
					</router-link>
					<hr>
					<router-link @click.native="toggleMenu" v-for="link in navMain" :to="link.link" :key="link.link" class="header-mobile__link"> {{ link.desc }} </router-link>
				</nav>
			</div>
		</div>
		<div class="header-mobile__lower">
			<img src="@/assets/images/header/major.png" alt class="header-mobile__major" />
		</div>
	</header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "headerMobile",
	computed: mapGetters({
		navTop: "navTop",
		navMain: "navMain"
	}),
	data() {
		return {
			translate: '-100%'
		}
	},
	methods: {
		toggleMenu() {
			(this.translate === '-100%') ? this.translate = '0%' : this.translate = '-100%'
		}
	}
};
</script>

<style lang="scss">
.header-mobile {
	&__upper {
		background: #f1f1f1;
	}

	&__wrapper {
		width: 95%;
		margin: auto;
		display: flex;
        align-items: center;
		justify-content: space-between;
		padding-bottom: 50px
	}

	&__nav {
		position: fixed;
		height: 100vh;
		z-index: 999;
		top: 0;
		left: 0;
		background: white;
		width: 90%;
		max-width: 350px;
		overflow: auto;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);
		display: flex;
		flex-direction: column;
		transition: all 200ms;
		&-toggle {
			padding: 20px;
		}
		&-header {
			display: flex;
			align-items: center;
			justify-content: space-around;
		}
	}

	&__link {
		padding: 15px 30px;
		display: flex;
		align-items: center;
		color: #505050;
		&.router-link-exact-active {
			font-weight: bold;
		}
	}

	&__icon {
		margin-right: 20px;
		object-fit: scale-down;
		width: 30px;
		height: 20px;
	}

	&__major {
    width: 95%;
    margin: auto;
    display: block;
    margin-top: -50px;
	}
}
</style>
